import { useParams } from "react-router";
import RedeemConfirmation from "./RedeemConfirmation";

// Wrapper component to handle route parameters
const RedeemConfirmationWrapper = () => {
    const { type = 'bank' } = useParams<{ type: string }>();
    const processType = (type === 'bank' || type === 'e-wallet') ? type : 'bank';
    
    return <RedeemConfirmation type={processType as 'bank' | 'e-wallet'} />;
  };

  export default RedeemConfirmationWrapper;